import $ from "jquery";
import Field from "./../field";
import Pikaday from "pikaday/";

const DateField = (($) => {
  class DateField extends Field {
    render() {
      let id = this.getForm().getID() + "_field_" + this._field.formFieldID;

      this._element = document.createElement("div");
      this._element.classList.add("ion-form-group");
      this._element.classList.add("ion-form-group-date");

      // Label
      this._label = document.createElement("label");
      this._label.htmlFor = id;
      this._label.innerText = this._field.label;
      this._element.appendChild(this._label);

      // Default Value
      let defaultValue = this.getSetting("defaultValue");

      // Placeholder
      let usePlaceholders = this.getForm()._config.placeholder;
      let placeholder = usePlaceholders === true ? this._label.innerText : this.getSetting("placeholder");

      // Input
      this._input = document.createElement("input");
      this._input.id = id;
      this._input.type = "text";
      this._input.classList.add("ion-form-control");
      this._input.name = this._field.slug;
      this._input.ariaLabel = this._field.label;
      this._element.appendChild(this._input);

      let isRequired = this.getSetting("isRequired", false);
      if (isRequired == "1") {
        this._element.classList.add("ion-is-required");
        this._input.ariaRequired = true;
      }

      this._picker = new Pikaday({ field: this._input, format: "MM/DD/YYYY" });

      if (placeholder) {
        this._input.placeholder = placeholder;
        this._input.ariaLabel = placeholder;
      }

      if (defaultValue) {
        this._input.value = defaultValue;
      }

      // Instructions
      let instructions = this._renderInstructions();
      if (instructions) {
        this._element.appendChild(instructions);
      }

      this._renderMessages();
      if (this._messages) {
        this._element.appendChild(this._messages);
      }
    }
  }

  return DateField;
})($);

export default DateField;
